import { shallowRef, watch } from 'vue'

interface RouteRefreshSignal {
  key: string
  serial: number
}

const routeRefreshSignal = shallowRef<RouteRefreshSignal | null>(null)
let routeRefreshSerial = 0

export function requestRouteRefresh(key: string) {
  routeRefreshSerial += 1
  routeRefreshSignal.value = {
    key,
    serial: routeRefreshSerial,
  }
}

export function useRouteRefreshSignal(key: string, refresh: () => void | Promise<void>) {
  watch(routeRefreshSignal, (signal) => {
    if (signal?.key !== key) {
      return
    }

    void refresh()
  })
}
